export default __webpack_public_path__ + "static/media/vegan-000000.6d170122.png";